module.exports = require("filesafe-js");


//////////////////
// WEBPACK FOOTER
// external "filesafe-js"
// module id = 7
// module chunks = 0 1